<template>
  <div>
    <h2>Application Review</h2>
    <p>Please take the time to review your application. If you are happy with your application you can confirm your submission, however if you wish to update it you can click the edit application button at the bottom of the form to make any amendments.</p>
    <!-- Personal Details Section Review -->
    <section class="form-section">
      <h4>Personal Details</h4>
      <h6>Declaration box ticked?</h6>
      <p>{{ recruit.rightToWork ? 'Yes' : 'No' }}</p>
      <h6>Title</h6>
      <p>{{ recruit.title ? recruit.title : '-' }}</p>
      <h6>First Name</h6>
      <p>{{ recruit.firstname ? recruit.firstname : '-' }}</p>
      <h6>Last Name</h6>
      <p>{{ recruit.surname ? recruit.surname : '-' }}</p>
      <h6>Email</h6>
      <p>{{ recruit.email ? recruit.email : '-' }}</p>
      <h6>Mobile Phone Number</h6>
      <p>{{ recruit.phoneMob ? recruit.phoneMob : '-' }}</p>
      <h6>Home Phone Number</h6>
      <p>{{ recruit.phoneHome ? recruit.phoneHome : '-' }}</p>
      <h6>Address Line 1</h6>
      <p>{{ recruit.address1 ? recruit.address1 : '-' }}</p>
      <h6>Address Line 2</h6>
      <p>{{ recruit.address2 ? recruit.address2 : '-' }}</p>
      <h6>Address Line 3</h6>
      <p>{{ recruit.address3 ? recruit.address3 : '-' }}</p>
      <h6>Address Line 4</h6>
      <p>{{ recruit.address4 ? recruit.address4 : '-' }}</p>
      <h6>{{ referer === 'UK' ? 'Postcode' : 'Eircode' }}</h6>
      <p>{{ recruit.postcode ? recruit.postcode : '-' }}</p>
      <h6>Selected Travel Centres</h6>
      <template v-if="recruit.centres.length">
        <p v-for="(item, index) in recruit.centres" :key="item + '-' + index">{{ item }}</p>
      </template>
      <p v-else>-</p>
    </section>
    <!-- Educational Qualifications Section Review -->
    <section class="form-section">
      <h4>Educational Details</h4>
      <h6>Qualification</h6>
      <p>{{ recruit.qualifications.qualification ? recruit.qualifications.qualification : '-' }}</p>
      <h6>Completion Date</h6>
      <p>{{ recruit.qualifications.qualificationWhen ? recruit.qualifications.qualificationWhen : '-' }}</p>
      <h6>Name of School/University</h6>
      <p>{{ recruit.qualifications.qualificationWhere ? recruit.qualifications.qualificationWhere : '-' }}</p>
      <h6>2nd Qualification</h6>
      <p>{{ recruit.qualifications.qualification2 ? recruit.qualifications.qualification2 : '-' }}</p>
      <h6>Completion Date</h6>
      <p>{{ recruit.qualifications.qualificationWhen2 ? recruit.qualifications.qualificationWhen2 : '-' }}</p>
      <h6>Name of School/University</h6>
      <p>{{ recruit.qualifications.qualificationWhere2 ? recruit.qualifications.qualificationWhere2 : '-' }}</p>
    </section>
    <!-- Employment History Section Review -->
    <section class="form-section">
      <h4>Employment History</h4>
      <h5>Current/Most Recent Employer</h5>
      <h6>Company Name</h6>
      <p>{{ recruit.previousEmployment.currEmployer ? recruit.previousEmployment.currEmployer : '-' }}</p>
      <h6>Job Title</h6>
      <p>{{ recruit.previousEmployment.currJobTitle ? recruit.previousEmployment.currJobTitle : '-' }}</p>
      <h6>Start Date</h6>
      <p>{{ recruit.previousEmployment.currStartDate ? recruit.previousEmployment.currStartDate : '-' }}</p>
      <h6>End Date</h6>
      <p>{{ recruit.previousEmployment.currEndDate ? recruit.previousEmployment.currEndDate : '-' }}</p>
      <h6>Still in current role?</h6>
      <p>{{ recruit.previousEmployment.currStillEmployed ? 'Yes' : 'No' }}</p>
      <h6>Salary and Benefits</h6>
      <p>{{ recruit.previousEmployment.currSalary ? recruit.previousEmployment.currSalary : '-' }}</p>
      <h6>Duties and Responsibilities</h6>
      <p>{{ recruit.previousEmployment.currDuties ? recruit.previousEmployment.currDuties : '-' }}</p>
      <h6>Reason for Leaving</h6>
      <p>{{ recruit.previousEmployment.currWhyLeave ? recruit.previousEmployment.currWhyLeave : '-' }}</p>
      <h6>Notice Period</h6>
      <p>{{ recruit.previousEmployment.currNotice ? recruit.previousEmployment.currNotice : '-' }}</p>
      <h6>Was the position full or part time</h6>
      <p>{{ recruit.previousEmployment.currFullPartTime ? recruit.previousEmployment.currFullPartTime : '-' }}</p>
      <h6>Number of hours per week</h6>
      <p>{{ recruit.previousEmployment.currNumHours ? recruit.previousEmployment.currNumHours : '-' }}</p>
      <h5>Previous Employer</h5>
      <h6>Company Name</h6>
      <p>{{ recruit.previousEmployment.preEmployer ? recruit.previousEmployment.preEmployer : '-' }}</p>
      <h6>Job Title</h6>
      <p>{{ recruit.previousEmployment.preJobTitle ? recruit.previousEmployment.preJobTitle : '-' }}</p>
      <h6>Start / End Dates</h6>
      <p>{{ recruit.previousEmployment.preDates ? recruit.previousEmployment.preDates : '-' }}</p>
      <!-- <h6>End Date</h6>
      <p>{{ recruit.previousEmployment.currEndDate ? recruit.previousEmployment.currEndDate : '-' }}</p> -->
      <h6>Salary and Benefits</h6>
      <p>{{ recruit.previousEmployment.preSalary ? recruit.previousEmployment.preSalary : '-' }}</p>
      <h6>Duties and Responsibilities</h6>
      <p>{{ recruit.previousEmployment.preDuties ? recruit.previousEmployment.preDuties : '-' }}</p>
      <h6>Reason for Leaving</h6>
      <p>{{ recruit.previousEmployment.preWhyLeave ? recruit.previousEmployment.preWhyLeave : '-' }}</p>
      <h6>Other experience</h6>
      <p>{{ recruit.previousEmployment.otherExp ? recruit.previousEmployment.otherExp : '-' }}</p>
    </section>
    <!-- Work Examples Section Review -->
    <section class="form-section">
      <h4>Work Examples</h4>
      <h6>Rapport</h6>
      <p>{{ recruit.workExamples.workExampleRapport ? recruit.workExamples.workExampleRapport : '-' }}</p>
      <h6>Sales</h6>
      <p>{{ recruit.workExamples.workExampleSale ? recruit.workExamples.workExampleSale : '-' }}</p>
      <h6>Geography</h6>
      <p>{{ recruit.workExamples.workExampleGeography ? recruit.workExamples.workExampleGeography : '-' }}</p>
      <h6>Technology</h6>
      <p>{{ recruit.workExamples.workExampleTech ? recruit.workExamples.workExampleTech : '-' }}</p>
      <h6>Education</h6>
      <p>{{ recruit.workExamples.workExampleEducation ? recruit.workExamples.workExampleEducation : '-' }}</p>
      <h6>Management</h6>
      <p>{{ recruit.workExamples.workExampleManagement ? recruit.workExamples.workExampleManagement : '-' }}</p>
    </section>
    <!-- Travel Experience Section Review -->
    <!-- <section class="form-section">
      <h4>Travel Experience</h4>
      <h6>Australasia</h6>
      <p>{{ recruit.whereBeen.whereAustralasia ? recruit.whereBeen.whereAustralasia : '-' }}</p>
      <h6>Asia</h6>
      <p>{{ recruit.whereBeen.whereAsia ? recruit.whereBeen.whereAsia : '-' }}</p>
      <h6>Africa</h6>
      <p>{{ recruit.whereBeen.whereAfrica ? recruit.whereBeen.whereAfrica : '-' }}</p>
      <h6>North America</h6>
      <p>{{ recruit.whereBeen.whereNorthAmerica ? recruit.whereBeen.whereNorthAmerica : '-' }}</p>
      <h6>South America</h6>
      <p>{{ recruit.whereBeen.whereSouthAmerica ? recruit.whereBeen.whereSouthAmerica : '-' }}</p>
    </section> -->
    <!-- Why You Section Review -->
    <section class="form-section">
      <h4>Why You</h4>
      <h6>Why are you the ideal candidate</h6>
      <p>{{ recruit.why ? recruit.why : '-' }}</p>
      <h6>How did you hear about this job opportunity</h6>
      <p>{{ recruit.hearabout ? recruit.hearabout : '-' }}</p>
      <template v-if="recruit.hearabout === 'Online Search'">
      <h6>Which website did you see the ad on</h6>
      <p>{{ recruit.hearaboutSearch ? recruit.hearaboutSearch : '-' }}</p>
      </template>
      <template v-if="recruit.hearabout === 'Other'">
      <h6>How did you hear about TF</h6>
      <p>{{ recruit.hearaboutOther ? recruit.hearaboutOther : '-' }}</p>
      </template>
      <!-- <h6>I confirm that I have read the Person Specification and Job Description</h6>
      <p>{{ recruit.confirm ? 'Yes' : 'No' }}</p> -->
    </section>

  </div>    
</template>

<script>
import { mapGetters, mapState } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      getRecruit: 'authStore/getRecruit'
    }),
    ...mapState({recruit: state => state.authStore.recruit}),
  },
  data () {
    return {
      referer: window.siteVar.referer
    }
  }
}
</script>

<style scoped>
.form-section p {
  color: #ffa409;
}
</style>